import { CustomCartItem } from './custom-cart-item.model';

export interface ICustomShopOrder {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    country: string;
    address: string;
    postal: string;
    city: string;
    status: string;
    payment_status: string;
    created_at: string;
    updated_at: string;
}

export class CustomShopOrder implements ICustomShopOrder {
    public id: number;
    public first_name: string; // tslint:disable-line: variable-name
    public last_name: string; // tslint:disable-line: variable-name
    public email: string;
    public country: string;
    public address: string;
    public postal: string;
    public city: string;
    public status: string;
    public payment_status: string; // tslint:disable-line: variable-name
    public shop_cart_items: CustomCartItem[]; // tslint:disable-line: variable-name
    public created_at: string; // tslint:disable-line: variable-name
    public updated_at: string; // tslint:disable-line: variable-name

    constructor(options: {
        id?: number,
        first_name?: string;
        last_name?: string;
        email?: string;
        country?: string;
        address?: string;
        postal?: string;
        city?: string;
        status?: string;
        payment_status?: string;
        shop_cart_items?: CustomCartItem[];
        created_at?: string,
        updated_at?: string,
    } = {}) {
        this.id = options.id || null;
        this.first_name = options.first_name || '';
        this.last_name = options.last_name || '';
        this.email = options.email || '';
        this.country = options.country || '';
        this.address = options.address || '';
        this.city = options.city || '';
        this.status = options.status || null;
        this.payment_status = options.payment_status || null;
        this.shop_cart_items = options.shop_cart_items || [];
        this.created_at = options.created_at || null;
        this.updated_at = options.updated_at || null;

    }
}
